import React from "react";
import { t } from "i18next";
import useShowUserInfoModal from "features/basket/useShowUserInfoModal";
import UserProfileForm from "pages/profile/components/profile-form";
import SlideInLayout from "components/layouts/SlideInLayout";

const AddUserInfoForm = () => {
  const { isOpenUserInfoModal, setUserInfoModal } = useShowUserInfoModal();

  return (
    <SlideInLayout
      open={isOpenUserInfoModal}
      handleClose={() => {}}
      disableOutsideClick={true}
      hideOutsideCloseButton={true}
      showHeader={true}
      showHeaderCloseButton={false}
      headerTitle={t("Update your profile")}
      container={{
        style: {
          height: "fit-content",
        },
      }}
    >
      <UserProfileForm
        isPage={false}
        setUserInfoModal={() => setUserInfoModal(false)}
        isOpenUserInfoModal={isOpenUserInfoModal}
      />
    </SlideInLayout>
  );
};

export default AddUserInfoForm;
